import * as PropTypes from 'prop-types';
import React from 'react';
import { allow } from '../classes/allow';
import getDomElementProps from '../functions/get.dom.element.props';
import is from '../objects/is';

const Div = props => {
   let classes = [];
   
   const addColumnClasses = () => {
      if (props.cols > 0)
         classes.push(`ds-l-col--${props.cols}`);
      if (props.colsXL > 0)
         classes.push(`ds-l-xl-col--${props.colsXL}`);
      if (props.colsLG > 0)
         classes.push(`ds-l-lg-col--${props.colsLG}`);
      if (props.colsMD > 0)
         classes.push(`ds-l-md-col--${props.colsMD}`);
      if (props.colsSM > 0)
         classes.push(`ds-l-sm-col--${props.colsSM}`);
   };
   
   const addContainerClass = () => {
      if (props.isContainer)
         classes.push('ds-l-container');
   };
   
   const addCustomClassNames = () => {
      if (props.className)
         classes.push(props.className);
   };
   
   const addFloatClasses = () => {
      if (props.float !== '')
         classes.push(`ds-u-float--${props.float}`);
      if (props.floatLG !== '')
         classes.push(`ds-u-lg-float--${props.floatLG}`);
      if (props.floatMD !== '')
         classes.push(`ds-u-md-float--${props.floatMD}`);
      if (props.floatSM !== '')
         classes.push(`ds-u-sm-float--${props.floatSM}`);
      if (props.floatXL !== '')
         classes.push(`ds-u-xl-float--${props.floatXL}`);
   };
   
   const addFontSizeClasses = () => {
      if (props.fontSize !== -1)
         classes.push(`ds-u-font-size--${getFontSizeName(props.fontSize)}`);
      if (props.fontSizeLG !== -1)
         classes.push(`ds-u-lg-font-size--${getFontSizeName(props.fontSizeLG)}`);
      if (props.fontSizeMD !== -1)
         classes.push(`ds-u-md-font-size--${getFontSizeName(props.fontSizeMD)}`);
      if (props.fontSizeSM !== -1)
         classes.push(`ds-u-sm-font-size--${getFontSizeName(props.fontSizeSM)}`);
      if (props.fontSizeXL !== -1)
         classes.push(`ds-u-xl-font-size--${getFontSizeName(props.fontSizeXL)}`);
   };
   
   const addFontWeightClasses = () => {
      if (props.fontWeight !== '')
         classes.push(`ds-u-font-weight--${props.fontWeight}`);
   };
   
   const addLineHeightClass = () => {
      if (props.lineHeight !== -1)
         classes.push(`ds-u-leading--${getLineHeightName(props.lineHeight)}`);
   };
   
   const addMarginClasses = () => {
      if (props.margin !== -1)
         classes.push(`ds-u-margin--${props.margin}`);
      if (props.marginBottom !== -1)
         classes.push(`ds-u-margin-bottom--${props.marginBottom}`);
      if (props.marginBottomLG !== -1)
         classes.push(`ds-u-lg-margin-bottom--${props.marginBottomLG}`);
      if (props.marginBottomMD !== -1)
         classes.push(`ds-u-md-margin-bottom--${props.marginBottomMD}`);
      if (props.marginBottomSM !== -1)
         classes.push(`ds-u-sm-margin-bottom--${props.marginBottomSM}`);
      if (props.marginBottomXL !== -1)
         classes.push(`ds-u-xl-margin-bottom--${props.marginBottomXL}`);
      if (props.marginLG !== -1)
         classes.push(`ds-u-lg-margin--${props.marginLG}`);
      if (props.marginLeft !== -1)
         classes.push(`ds-u-margin-left--${props.marginLeft}`);
      if (props.marginLeftLG !== -1)
         classes.push(`ds-u-lg-margin-left--${props.marginLeftLG}`);
      if (props.marginLeftMD !== -1)
         classes.push(`ds-u-md-margin-left--${props.marginLeftMD}`);
      if (props.marginLeftSM !== -1)
         classes.push(`ds-u-sm-margin-left--${props.marginLeftSM}`);
      if (props.marginLeftXL !== -1)
         classes.push(`ds-u-xl-margin-left--${props.marginLeftXL}`);
      if (props.marginMD !== -1)
         classes.push(`ds-u-md-margin--${props.marginMD}`);
      if (props.marginRight !== -1)
         classes.push(`ds-u-margin-right--${props.marginRight}`);
      if (props.marginRightLG !== -1)
         classes.push(`ds-u-lg-margin-right--${props.marginRightLG}`);
      if (props.marginRightMD !== -1)
         classes.push(`ds-u-md-margin-right--${props.marginRightMD}`);
      if (props.marginRightSM !== -1)
         classes.push(`ds-u-sm-margin-right--${props.marginRightSM}`);
      if (props.marginRightXL !== -1)
         classes.push(`ds-u-xl-margin-right--${props.marginRightXL}`);
      if (props.marginSM !== -1)
         classes.push(`ds-u-sm-margin--${props.marginSM}`);
      if (props.marginTop !== -1)
         classes.push(`ds-u-margin-top--${props.marginTop}`);
      if (props.marginTopLG !== -1)
         classes.push(`ds-u-lg-margin-top--${props.marginTopLG}`);
      if (props.marginTopMD !== -1)
         classes.push(`ds-u-md-margin-top--${props.marginTopMD}`);
      if (props.marginTopSM !== -1)
         classes.push(`ds-u-sm-margin-top--${props.marginTopSM}`);
      if (props.marginTopXL !== -1)
         classes.push(`ds-u-xl-margin-top--${props.marginTopXL}`);
      if (props.marginXL !== -1)
         classes.push(`ds-u-xl-margin--${props.marginXL}`);
      if (props.marginx !== -1)
         classes.push(`ds-u-margin-x--${props.marginx}`);
      if (props.marginxLG !== -1)
         classes.push(`ds-u-lg-margin-x--${props.marginxLG}`);
      if (props.marginxMD !== -1)
         classes.push(`ds-u-md-margin-x--${props.marginxMD}`);
      if (props.marginxSM !== -1)
         classes.push(`ds-u-sm-margin-x--${props.marginxSM}`);
      if (props.marginxXL !== -1)
         classes.push(`ds-u-xl-margin-x--${props.marginxXL}`);
      if (props.marginy !== -1)
         classes.push(`ds-u-margin-y--${props.marginy}`);
      if (props.marginyLG !== -1)
         classes.push(`ds-u-lg-margin-y--${props.marginyLG}`);
      if (props.marginyMD !== -1)
         classes.push(`ds-u-md-margin-y--${props.marginyMD}`);
      if (props.marginySM !== -1)
         classes.push(`ds-u-sm-margin-y--${props.marginySM}`);
      if (props.marginyXL !== -1)
         classes.push(`ds-u-xl-margin-y--${props.marginyXL}`);
   };
   
   const addPaddingClasses = () => {
      if (props.padding !== -1)
         classes.push(`ds-u-padding--${props.padding}`);
      if (props.paddingBottom !== -1)
         classes.push(`ds-u-padding-bottom--${props.paddingBottom}`);
      if (props.paddingBottomLG !== -1)
         classes.push(`ds-u-lg-padding-bottom--${props.paddingBottomLG}`);
      if (props.paddingBottomMD !== -1)
         classes.push(`ds-u-md-padding-bottom--${props.paddingBottomMD}`);
      if (props.paddingBottomSM !== -1)
         classes.push(`ds-u-sm-padding-bottom--${props.paddingBottomSM}`);
      if (props.paddingBottomXL !== -1)
         classes.push(`ds-u-xl-padding-bottom--${props.paddingBottomXL}`);
      if (props.paddingLG !== -1)
         classes.push(`ds-u-lg-padding--${props.paddingLG}`);
      if (props.paddingLeft !== -1)
         classes.push(`ds-u-padding-left--${props.paddingLeft}`);
      if (props.paddingLeftLG !== -1)
         classes.push(`ds-u-lg-padding-left--${props.paddingLeftLG}`);
      if (props.paddingLeftMD !== -1)
         classes.push(`ds-u-md-padding-left--${props.paddingLeftMD}`);
      if (props.paddingLeftSM !== -1)
         classes.push(`ds-u-sm-padding-left--${props.paddingLeftSM}`);
      if (props.paddingLeftXL !== -1)
         classes.push(`ds-u-xl-padding-left--${props.paddingLeftXL}`);
      if (props.paddingMD !== -1)
         classes.push(`ds-u-md-padding--${props.paddingMD}`);
      if (props.paddingRight !== -1)
         classes.push(`ds-u-padding-right--${props.paddingRight}`);
      if (props.paddingRightLG !== -1)
         classes.push(`ds-u-lg-padding-right--${props.paddingRightLG}`);
      if (props.paddingRightMD !== -1)
         classes.push(`ds-u-md-padding-right--${props.paddingRightMD}`);
      if (props.paddingRightSM !== -1)
         classes.push(`ds-u-sm-padding-right--${props.paddingRightSM}`);
      if (props.paddingRightXL !== -1)
         classes.push(`ds-u-xl-padding-right--${props.paddingRightXL}`);
      if (props.paddingSM !== -1)
         classes.push(`ds-u-sm-padding--${props.paddingSM}`);
      if (props.paddingTop !== -1)
         classes.push(`ds-u-padding-top--${props.paddingTop}`);
      if (props.paddingTopLG !== -1)
         classes.push(`ds-u-lg-padding-top--${props.paddingTopLG}`);
      if (props.paddingTopMD !== -1)
         classes.push(`ds-u-md-padding-top--${props.paddingTopMD}`);
      if (props.paddingTopSM !== -1)
         classes.push(`ds-u-sm-padding-top--${props.paddingTopSM}`);
      if (props.paddingTopXL !== -1)
         classes.push(`ds-u-xl-padding-top--${props.paddingTopXL}`);
      if (props.paddingXL !== -1)
         classes.push(`ds-u-xl-padding--${props.paddingXL}`);
      if (props.paddingx !== -1)
         classes.push(`ds-u-padding-x--${props.paddingx}`);
      if (props.paddingxLG !== -1)
         classes.push(`ds-u-lg-padding-x--${props.paddingxLG}`);
      if (props.paddingxMD !== -1)
         classes.push(`ds-u-md-padding-x--${props.paddingxMD}`);
      if (props.paddingxSM !== -1)
         classes.push(`ds-u-sm-padding-x--${props.paddingxSM}`);
      if (props.paddingxXL !== -1)
         classes.push(`ds-u-xl-padding-x--${props.paddingxXL}`);
      if (props.paddingy !== -1)
         classes.push(`ds-u-padding-y--${props.paddingy}`);
      if (props.paddingyLG !== -1)
         classes.push(`ds-u-lg-padding-y--${props.paddingyLG}`);
      if (props.paddingyMD !== -1)
         classes.push(`ds-u-md-padding-y--${props.paddingyMD}`);
      if (props.paddingySM !== -1)
         classes.push(`ds-u-sm-padding-y--${props.paddingySM}`);
      if (props.paddingyXL !== -1)
         classes.push(`ds-u-xl-padding-y--${props.paddingyXL}`);
   };
   
   const addRowClass = () => {
      if (props.isRow)
         classes.push('ds-l-row');
   };
   
   const getClasses = () => {
      addColumnClasses();
      addContainerClass();
      addCustomClassNames();
      addFloatClasses();
      addFontSizeClasses();
      addFontWeightClasses();
      addLineHeightClass();
      addMarginClasses();
      addPaddingClasses();
      addRowClass();
      classes = classes.join(' ');
      return classes;
   };
   
   const getFontSizeName = (fontSizeNumber = 0) => {
      allow.anInteger(fontSizeNumber, is.positive);
      switch (fontSizeNumber) {
         case 1:
            return 'small';
         case 2:
            return 'base';
         case 3:
            return 'lead';
         case 4:
            return 'h4';
         case 5:
            return 'h3';
         case 6:
            return 'h2';
         case 7:
            return 'h1';
         case 8:
            return 'title';
         case 9:
            return 'display';
         default:
            return 'small';
      }
   };
   
   const getLineHeightName = (lineHeightNumber = 0) => {
      allow.anInteger(lineHeightNumber, is.positive);
      switch (lineHeightNumber) {
         case 1:
            return 'reset';
         case 2:
            return 'heading';
         case 3:
            return 'base';
         case 4:
            return 'lead';
         default:
            return 'reset';
      }
   }
   
   return <>
      <div
         {...getDomElementProps(props)}
         className={getClasses()}
      >{props.children}</div>
   </>;
}

const floatOptions = ['', 'left', 'right', 'none'];
const fontSizeOptions = [-1, 1, 2, 3, 4, 5, 6, 7, 8, 9];
const spacingOptions = ['auto', -1, 0, 1, 2, 3, 4, 5, 6, 7];

Div.propTypes = {
   className: PropTypes.string,
   cols: PropTypes.number,
   colsLG: PropTypes.number,
   colsMD: PropTypes.number,
   colsSM: PropTypes.number,
   colsXL: PropTypes.number,
   float: PropTypes.oneOf(floatOptions),
   floatLG: PropTypes.oneOf(floatOptions),
   floatMD: PropTypes.oneOf(floatOptions),
   floatSM: PropTypes.oneOf(floatOptions),
   floatXL: PropTypes.oneOf(floatOptions),
   fontSize: PropTypes.oneOf(fontSizeOptions),
   fontSizeLG: PropTypes.oneOf(fontSizeOptions),
   fontSizeMD: PropTypes.oneOf(fontSizeOptions),
   fontSizeSM: PropTypes.oneOf(fontSizeOptions),
   fontSizeXL: PropTypes.oneOf(fontSizeOptions),
   fontWeight: PropTypes.oneOf(['', 'normal', 'semibold', 'bold']),
   id: PropTypes.string,
   isContainer: PropTypes.bool,
   isRow: PropTypes.bool,
   lineHeight: PropTypes.oneOf([-1, 1, 2, 3, 4]),
   margin: PropTypes.oneOf(spacingOptions),
   marginBottom: PropTypes.oneOf(spacingOptions),
   marginBottomLG: PropTypes.oneOf(spacingOptions),
   marginBottomMD: PropTypes.oneOf(spacingOptions),
   marginBottomSM: PropTypes.oneOf(spacingOptions),
   marginBottomXL: PropTypes.oneOf(spacingOptions),
   marginLG: PropTypes.oneOf(spacingOptions),
   marginLeft: PropTypes.oneOf(spacingOptions),
   marginLeftLG: PropTypes.oneOf(spacingOptions),
   marginLeftMD: PropTypes.oneOf(spacingOptions),
   marginLeftSM: PropTypes.oneOf(spacingOptions),
   marginLeftXL: PropTypes.oneOf(spacingOptions),
   marginMD: PropTypes.oneOf(spacingOptions),
   marginRight: PropTypes.oneOf(spacingOptions),
   marginRightLG: PropTypes.oneOf(spacingOptions),
   marginRightMD: PropTypes.oneOf(spacingOptions),
   marginRightSM: PropTypes.oneOf(spacingOptions),
   marginRightXL: PropTypes.oneOf(spacingOptions),
   marginSM: PropTypes.oneOf(spacingOptions),
   marginTop: PropTypes.oneOf(spacingOptions),
   marginTopLG: PropTypes.oneOf(spacingOptions),
   marginTopMD: PropTypes.oneOf(spacingOptions),
   marginTopSM: PropTypes.oneOf(spacingOptions),
   marginTopXL: PropTypes.oneOf(spacingOptions),
   marginXL: PropTypes.oneOf(spacingOptions),
   marginx: PropTypes.oneOf(spacingOptions),
   marginxLG: PropTypes.oneOf(spacingOptions),
   marginxMD: PropTypes.oneOf(spacingOptions),
   marginxSM: PropTypes.oneOf(spacingOptions),
   marginxXL: PropTypes.oneOf(spacingOptions),
   marginy: PropTypes.oneOf(spacingOptions),
   marginyLG: PropTypes.oneOf(spacingOptions),
   marginyMD: PropTypes.oneOf(spacingOptions),
   marginySM: PropTypes.oneOf(spacingOptions),
   marginyXL: PropTypes.oneOf(spacingOptions),
   padding: PropTypes.oneOf(spacingOptions),
   paddingBottom: PropTypes.oneOf(spacingOptions),
   paddingBottomLG: PropTypes.oneOf(spacingOptions),
   paddingBottomMD: PropTypes.oneOf(spacingOptions),
   paddingBottomSM: PropTypes.oneOf(spacingOptions),
   paddingBottomXL: PropTypes.oneOf(spacingOptions),
   paddingLG: PropTypes.oneOf(spacingOptions),
   paddingLeft: PropTypes.oneOf(spacingOptions),
   paddingLeftLG: PropTypes.oneOf(spacingOptions),
   paddingLeftMD: PropTypes.oneOf(spacingOptions),
   paddingLeftSM: PropTypes.oneOf(spacingOptions),
   paddingLeftXL: PropTypes.oneOf(spacingOptions),
   paddingMD: PropTypes.oneOf(spacingOptions),
   paddingRight: PropTypes.oneOf(spacingOptions),
   paddingRightLG: PropTypes.oneOf(spacingOptions),
   paddingRightMD: PropTypes.oneOf(spacingOptions),
   paddingRightSM: PropTypes.oneOf(spacingOptions),
   paddingRightXL: PropTypes.oneOf(spacingOptions),
   paddingSM: PropTypes.oneOf(spacingOptions),
   paddingTop: PropTypes.oneOf(spacingOptions),
   paddingTopLG: PropTypes.oneOf(spacingOptions),
   paddingTopMD: PropTypes.oneOf(spacingOptions),
   paddingTopSM: PropTypes.oneOf(spacingOptions),
   paddingTopXL: PropTypes.oneOf(spacingOptions),
   paddingXL: PropTypes.oneOf(spacingOptions),
   paddingx: PropTypes.oneOf(spacingOptions),
   paddingxLG: PropTypes.oneOf(spacingOptions),
   paddingxMD: PropTypes.oneOf(spacingOptions),
   paddingxSM: PropTypes.oneOf(spacingOptions),
   paddingxXL: PropTypes.oneOf(spacingOptions),
   paddingy: PropTypes.oneOf(spacingOptions),
   paddingyLG: PropTypes.oneOf(spacingOptions),
   paddingyMD: PropTypes.oneOf(spacingOptions),
   paddingySM: PropTypes.oneOf(spacingOptions),
   paddingyXL: PropTypes.oneOf(spacingOptions),
   style: PropTypes.object,
};
Div.defaultProps = {
   className: '',
   cols: -1,
   colsLG: -1,
   colsMD: -1,
   colsSM: -1,
   colsXL: -1,
   float: '',
   floatLG: '',
   floatMD: '',
   floatSM: '',
   floatXL: '',
   fontSize: -1,
   fontSizeLG: -1,
   fontSizeMD: -1,
   fontSizeSM: -1,
   fontSizeXL: -1,
   fontWeight: '',
   id: '',
   isContainer: false,
   isRow: false,
   lineHeight: -1,
   margin: -1,
   marginBottom: -1,
   marginBottomLG: -1,
   marginBottomMD: -1,
   marginBottomSM: -1,
   marginBottomXL: -1,
   marginLG: -1,
   marginLeft: -1,
   marginLeftLG: -1,
   marginLeftMD: -1,
   marginLeftSM: -1,
   marginLeftXL: -1,
   marginMD: -1,
   marginRight: -1,
   marginRightLG: -1,
   marginRightMD: -1,
   marginRightSM: -1,
   marginRightXL: -1,
   marginSM: -1,
   marginTop: -1,
   marginTopLG: -1,
   marginTopMD: -1,
   marginTopSM: -1,
   marginTopXL: -1,
   marginx: -1,
   marginXL: -1,
   marginxLG: -1,
   marginxMD: -1,
   marginxSM: -1,
   marginxXL: -1,
   marginy: -1,
   marginyLG: -1,
   marginyMD: -1,
   marginySM: -1,
   marginyXL: -1,
   padding: -1,
   paddingBottom: -1,
   paddingBottomLG: -1,
   paddingBottomMD: -1,
   paddingBottomSM: -1,
   paddingBottomXL: -1,
   paddingLG: -1,
   paddingLeft: -1,
   paddingLeftLG: -1,
   paddingLeftMD: -1,
   paddingLeftSM: -1,
   paddingLeftXL: -1,
   paddingMD: -1,
   paddingRight: -1,
   paddingRightLG: -1,
   paddingRightMD: -1,
   paddingRightSM: -1,
   paddingRightXL: -1,
   paddingSM: -1,
   paddingTop: -1,
   paddingTopLG: -1,
   paddingTopMD: -1,
   paddingTopSM: -1,
   paddingTopXL: -1,
   paddingXL: -1,
   paddingx: -1,
   paddingxLG: -1,
   paddingxMD: -1,
   paddingxSM: -1,
   paddingxXL: -1,
   paddingy: -1,
   paddingyLG: -1,
   paddingyMD: -1,
   paddingySM: -1,
   paddingyXL: -1,
   style: {},
};

export default Div;